import React from "react";
import {useSelector, useDispatch} from "react-redux";

import { currentPageSelector, numberOfRequirementsSelector } from "../../../../store/ducks/requirementList/selectors";
import { changePage } from "../../../../store/ducks/requirementList";

import {useFilterContext} from "../SearchFilter/FilterContext";

import { fetchRequirements } from "../../../../usecases/requirement/requirementListUseCase";

import Prompt from "../../../../components/Prompt";
import TablePagination from "@mui/material/TablePagination";
import { getItemFromLocalStorage } from "../../../../config/localStorage";


export function RequirementListPagination() {
  const dispatch = useDispatch();

  const {getFilter} = useFilterContext();

  const numberOfRequirements = useSelector(numberOfRequirementsSelector);
  const currentPage = useSelector(currentPageSelector);

  const onChangePage = React.useCallback(
    (
      event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
      newPage: number,
    ) => {
      const queryParams = getItemFromLocalStorage("queryParams", "");
      const withFilter = queryParams.includes("filter");
      dispatch(changePage(newPage));
      const filter = withFilter ? getFilter() : null;
      fetchRequirements(`?${filter}`, newPage, 10)(dispatch);
    },
    [],
  );

  return (
    <Prompt>
      <TablePagination
        component="div"
        count={numberOfRequirements}
        page={currentPage}
        onPageChange={onChangePage}
        rowsPerPage={10}
        rowsPerPageOptions={[]}
      />
    </Prompt>
  );
}